module.exports = new __parcel__URL__("PlacesListEmpty_ptc.36d458cf.svg").toString();